import { render, staticRenderFns } from "./TpmAnalyticsMaintenance.vue?vue&type=template&id=66b4f972"
import script from "./TpmAnalyticsMaintenance.vue?vue&type=script&lang=ts"
export * from "./TpmAnalyticsMaintenance.vue?vue&type=script&lang=ts"
import style0 from "./TpmAnalyticsMaintenance.vue?vue&type=style&index=0&id=66b4f972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports